import React from "react";
import { motion } from "framer-motion";

const PILLARS = [
  { label: "Data & AI Innovation", num: "01" },
  { label: "Financial Intelligence", num: "02" },
  { label: "Business Growth", num: "03" },
  { label: "Digital Transformation", num: "04" },
  { label: "Creative Design Excellence", num: "05" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="text-xs font-mono uppercase tracking-[0.3em] text-blue-400" data-testid="about-overline">
            [ About Us / 05 ]
          </div>
          <h2
            className="mt-5 font-display text-4xl md:text-5xl font-medium tracking-tight"
            data-testid="about-heading"
          >
            A modern solutions
            <br />
            <span className="text-zinc-500">company.</span>
          </h2>
          <p className="mt-6 text-zinc-300 text-base md:text-lg leading-relaxed">
            Dataviqu is built around a simple idea: complexity shouldn&apos;t be an excuse for slow, ugly, or generic work.
          </p>
          <p className="mt-4 text-zinc-400 text-base leading-relaxed">
            We bring together engineers, financial analysts, and designers under one roof — so the AI we ship is grounded in real numbers, and the brand work we craft is rooted in real strategy. We partner with founders, finance leaders, and product teams who want intelligent, beautifully-executed solutions to the problems that actually matter.
          </p>

          <div className="mt-10 relative overflow-hidden rounded-2xl border border-white/10">
            <img
              src="https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc4MTQyOTYwMnww&ixlib=rb-4.1.0&q=85"
              alt="Modern office architecture"
              data-testid="about-image"
              className="w-full h-72 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-7 lg:pl-8"
        >
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 mb-8">
            What we focus on
          </div>
          <div className="flex flex-col">
            {PILLARS.map((p, i) => (
              <motion.div
                key={p.num}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group flex items-center justify-between gap-6 py-7 border-t border-white/10 last:border-b hover:bg-white/[0.02] transition-colors px-2"
                data-testid={`about-pillar-${i}`}
              >
                <div className="flex items-center gap-6 md:gap-10">
                  <span className="font-mono text-xs text-zinc-500 tracking-widest">{p.num}</span>
                  <span className="font-display text-2xl md:text-3xl font-light tracking-tight group-hover:text-blue-400 transition-colors">
                    {p.label}
                  </span>
                </div>
                {/* <span className="text-zinc-500 group-hover:text-blue-400 group-hover:translate-x-1 transition-all">
                  →
                </span> */}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
